<template>
  <div class="app">
    <div class="Modal"></div>
    <div class="Card">
      <div class="titulo">
        <h1>{{ Titulo }}</h1>
      </div>
      <div class="texto">
        <p>{{ Texto }}</p>
      </div>
      <div class="boton">
        <button :style="Color" v-on:click="Aceptar">Accepted</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({}),
  props: {
    Titulo: String,
    Texto: String,
    Color: String,
  },
  methods: {
    Aceptar() {
      this.$emit("Aceptar", false);
    },
  },
};
</script>
<style lang="css" scoped>
.app {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}
.Modal {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: black;
  z-index: 99;
  opacity: 0.6;
}
.Card {
  width: 30%;
  height: auto;
  z-index: 999;
  background: white;
  opacity: 1;
  box-shadow: 1px 1px 2px 2px #fff;
  font-family: "Poppins", sans-serif;
  text-align: center;
  border-radius: 20px;
  padding: 10px;
}
.titulo {
  height: 20%;
}
.texto {
  height: 40%;
  padding: 10px;
}
.boton {
  height: 20%;
  display: flex;
  margin-right: 5%;
  justify-content: flex-end;
  align-items: flex-end;
  bottom: 10px;
}
.boton button {
  width: 100px;
  height: 2.7rem;
  border: none;
  border-radius: 15px;
  color: #fff;
  font-size: 15px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  outline: none;
}
@media (max-width: 1100px) {
  .Card {
    width: 40%;
    height: 30%;
  }
  .boton button {
    margin-bottom: -20px;
  }
}
@media (max-width: 800px) {
  .Card {
    width: 75%;
    height: 30%;
  }
  .titulo h1 {
    color: black;
  }
  .texto p {
    color: black;
  }
}
@media (max-width: 408px) {
  .Card {
    width: 75%;
    height: 50%;
  }
  .boton button {
    margin-bottom: -40px;
  }
}
</style>